import React from 'react'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
import TopBar from "../Components/TopBar"
function Master() {
  return (
    <>
    <TopBar/>
    <Header/>
    <Outlet/>
    <Footer/>
    </>
  )
}

export default Master